import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5l0 14","key":"svg-0"}],["path",{"d":"M18 11l-6 -6","key":"svg-1"}],["path",{"d":"M6 11l6 -6","key":"svg-2"}]]

/**
 * IconArrowUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDVsMCAxNCIgLz4KICA8cGF0aCBkPSJNMTggMTFsLTYgLTYiIC8+CiAgPHBhdGggZD0iTTYgMTFsNiAtNiIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUp = createReactComponent('outline', 'arrow-up', 'ArrowUp', __iconNode);

export default IconArrowUp;